import { ref } from 'vue'
import apiClient from '../api/axios.js'

// 表情 / 背景动作开关的确认与下发流程
// 外部依赖：
//   deviceId     - 当前设备ID (Ref)
//   selectedEnv  - 当前环境对象 (Ref，需含 manager_url)
//   showSnackbar - 显示提示信息的回调 (msg: string) => void
export function useEmotionState({ deviceId, selectedEnv, showSnackbar }) {
  const selectedEmotionState = ref(null)          // 选中的表情状态
  const selectedBackgroundActionState = ref(null) // 选中的背景动作状态
  const actionConfirmDialog = ref(false)          // 确认对话框
  const actionConfirmMessage = ref('')            // 确认消息
  const pendingAction = ref(null)                 // 待执行的操作 { type: 'emotion' | 'background', enabled: boolean }

  // 重置待执行操作对应的选择状态
  function resetPendingSelection() {
    if (!pendingAction.value) return
    if (pendingAction.value.type === 'emotion') {
      selectedEmotionState.value = null
    } else {
      selectedBackgroundActionState.value = null
    }
    pendingAction.value = null
  }

  // 处理表情状态变化
  function handleEmotionStateChange(value) {
    if (value === null) {
      selectedEmotionState.value = null
      return
    }
    if (!deviceId.value) {
      showSnackbar('请先选择设备ID')
      selectedEmotionState.value = null
      return
    }
    pendingAction.value = { type: 'emotion', enabled: value }
    actionConfirmMessage.value = `确认${value ? '开启' : '关闭'}表情吗？`
    actionConfirmDialog.value = true
  }

  // 处理背景动作状态变化
  function handleBackgroundActionStateChange(value) {
    if (value === null) {
      selectedBackgroundActionState.value = null
      return
    }
    if (!deviceId.value) {
      showSnackbar('请先选择设备ID')
      selectedBackgroundActionState.value = null
      return
    }
    pendingAction.value = { type: 'background', enabled: value }
    actionConfirmMessage.value = `确认${value ? '开启' : '关闭'}背景动作吗？`
    actionConfirmDialog.value = true
  }

  // 取消操作
  function cancelAction() {
    actionConfirmDialog.value = false
    resetPendingSelection()
  }

  // 处理确认对话框关闭
  function handleConfirmDialogClose(value) {
    if (!value && pendingAction.value) {
      resetPendingSelection()
    }
  }

  // 确认执行操作
  function confirmAction() {
    if (!pendingAction.value || !deviceId.value) {
      actionConfirmDialog.value = false
      return
    }

    const { type, enabled } = pendingAction.value
    const operate = type === 'emotion' ? 8 : 7
    const actionName = type === 'emotion' ? '表情' : '背景动作'

    const params = {
      device_id: deviceId.value,
      params: {
        name: 'self.servo.debug',
        arguments: {
          operate: operate,
          data: enabled ? 1 : 0,
          node: 0
        }
      }
    }

    apiClient.post(selectedEnv.value.manager_url + '/xiaozhi/device/send-message', params, {
      headers: { 'Content-Type': 'application/json' }
    }).then(() => {
      actionConfirmDialog.value = false
      showSnackbar(`${actionName}已${enabled ? '开启' : '关闭'}`)
      // 操作成功后重置选择状态（因为无法实时获取实际状态）
      resetPendingSelection()
    }).catch(err => {
      actionConfirmDialog.value = false
      showSnackbar('操作失败：' + (err.response?.data?.message || err.message))
      // 失败时重置选择状态
      resetPendingSelection()
    })
  }

  return {
    selectedEmotionState,
    selectedBackgroundActionState,
    actionConfirmDialog,
    actionConfirmMessage,
    pendingAction,
    handleEmotionStateChange,
    handleBackgroundActionStateChange,
    cancelAction,
    handleConfirmDialogClose,
    confirmAction
  }
}
